import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export enum EIntegrationKind {
    Form = 0,
    OAuth = 1,
    Native = 2,
    NotAvailable = 3,
    /// Tem tela própria; o card só abre ela.
    Managed = 4,
}

export interface IntegrationField {
    key: string;
    label: string;
    secret: boolean;
    required: boolean;
    placeholder?: string | null;
    help?: string | null;
    /// Segredo já gravado volta mascarado; reenviar a máscara mantém o valor.
    filled: boolean;
    value: string;
    /// Quando vem preenchido, a tela mostra lista em vez de campo livre.
    optionsSource?: string | null;
    /// Chave de outro campo cujo valor a lista precisa para carregar.
    optionsDependsOn?: string | null;
    /// Guarda varios valores separados por virgula.
    optionsMultiple?: boolean;
    /// Chave do passo do assistente onde este campo aparece.
    step?: string | null;
}

export interface IntegrationOption {
    value: string;
    label: string;
}

export interface Integration {
    key: string;
    name: string;
    description: string;
    category: string;
    kind: EIntegrationKind;
    configured: boolean;
    enabled: boolean;
    accountLabel?: string | null;
    connectedAt?: string | null;
    connectedByUserName?: string | null;
    fields: IntegrationField[];
    /// Vazio mantem a tela de pagina unica.
    steps?: IntegrationStep[] | null;
    /// Integracoes do mesmo grupo aparecem num card so.
    groupKey?: string | null;
    groupName?: string | null;
    groupDescription?: string | null;
    /// Quem autorizou, do lado do fornecedor; nulo se a conexão não resolve perfil (Chatwoot).
    connectedAccountName?: string | null;
    connectedAccountPicture?: string | null;
    /// Endereço que o cliente cadastra no fornecedor, relativo à API; {Campo} vira o valor do campo.
    /// As credenciais do servidor estão lá. Falso: só o suporte resolve.
    serverConfigured: boolean;
    /// O botão "Conectar com…" tem o aplicativo da mgcode para levar à conta.
    canConnect: boolean;
}

export interface IntegrationStep {
    key: string;
    title: string;
    description: string;
}

export class IntegrationService extends BaseService {
    protected get resourceName(): string {
        return 'crm/integrations';
    }

    public async list(): Promise<AxiosResponse<{ data: Integration[] }>> {
        return await this.get('');
    }

    public async save(
        key: string,
        enabled: boolean,
        fields: Record<string, string>
    ): Promise<AxiosResponse<void>> {
        return await this.put(key, { enabled, fields });
    }

    /// Opcoes de um campo que o catalogo marcou com optionsSource.
    public async options(
        source: string,
        depends?: string
    ): Promise<AxiosResponse<{ data: IntegrationOption[] }>> {
        return await this.get(
            `options/${encodeURIComponent(source)}`,
            depends ? { depends } : undefined);
    }

    public async disconnect(key: string): Promise<AxiosResponse<void>> {
        return await this.delete(key);
    }

    /// Mercado Pago, Stripe e RD Station: a mesma resposta do da Meta.
    public async accountConnectUrl(key: string): Promise<
        AxiosResponse<{ data: { ready: boolean; url?: string; reason?: string } }>
    > {
        return await this.get(`accounts/${key}/connect`);
    }

    public async metaConnectUrl(): Promise<
        AxiosResponse<{ data: { ready: boolean; url?: string; reason?: string } }>
    > {
        return await this.get('meta/connect');
    }

    /// Quem autorizou, do lado do Facebook; buscado ao vivo quando a conexão é anterior a este campo.
    public async metaAccount(): Promise<
        AxiosResponse<{ data: { name?: string | null; picture?: string | null } | null }>
    > {
        return await this.get('meta/account');
    }
}
